"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationIdsSelector = exports.notificationEntitiesSelector = exports.getUnreadNotificationCountsSelector = exports.getUnreadNotificationCountByCategorySelector = exports.getUnreadCallLogs = exports.getNotificationTotalCountsSelector = exports.getNotificationByIdSelector = exports.getLoadingNotificationByCategory = exports.getCurrentNotificationCategorySelector = exports.getAllCallLogs = exports._getUnreadCallLogs = exports._getAllNotificationsByCategory = exports._getAllCallLogs = void 0;
var _reselect = require("reselect");
var _selectors = require("../entities/selectors");
var _getCategoryParameter = (state, category) => category;
var notificationEntitiesSelector = state => (0, _selectors.entitiesSelector)(state).notifications;
exports.notificationEntitiesSelector = notificationEntitiesSelector;
var notificationIdsSelector = state => state.notifications.items;
exports.notificationIdsSelector = notificationIdsSelector;
var getUnreadNotificationCountsSelector = state => state.notifications.unreadCountByCategory;
exports.getUnreadNotificationCountsSelector = getUnreadNotificationCountsSelector;
var getNotificationTotalCountsSelector = state => state.notifications.totalCountByCategory;
exports.getNotificationTotalCountsSelector = getNotificationTotalCountsSelector;
var getCurrentNotificationCategorySelector = state => state.notifications.currentCategory;
exports.getCurrentNotificationCategorySelector = getCurrentNotificationCategorySelector;
var _getNotificationIdParameter = (state, _notification) => _notification;
var _getUnreadCallLogs = state => state.notifications.room_all_unread;
exports._getUnreadCallLogs = _getUnreadCallLogs;
var _getAllCallLogs = state => state.notifications.room_all;
exports._getAllCallLogs = _getAllCallLogs;
var _getAllNotificationsByCategory = (state, category) => state.notifications["".concat(category, "_all")];
exports._getAllNotificationsByCategory = _getAllNotificationsByCategory;
var getLoadingNotificationByCategory = (state, category) => state.notifications["".concat(category, "_loading")];
exports.getLoadingNotificationByCategory = getLoadingNotificationByCategory;
var getNotificationByIdSelector = exports.getNotificationByIdSelector = (0, _reselect.createSelector)([_getNotificationIdParameter, notificationEntitiesSelector], (_notification, notifications) => notifications === null || notifications === void 0 ? void 0 : notifications[_notification]);
var getUnreadNotificationCountByCategorySelector = exports.getUnreadNotificationCountByCategorySelector = (0, _reselect.createSelector)([_getCategoryParameter, getUnreadNotificationCountsSelector], (category, unreadCounts) => unreadCounts === null || unreadCounts === void 0 ? void 0 : unreadCounts[category]);
var getUnreadCallLogs = exports.getUnreadCallLogs = (0, _reselect.createSelector)([_getUnreadCallLogs, notificationEntitiesSelector], (_notifications, notifications) => {
  if (!_notifications) return [];
  return _notifications.reduce((acc, n) => {
    if (notifications[n]) acc.push(notifications[n]);
    return acc;
  }, []);
});
var getAllCallLogs = exports.getAllCallLogs = (0, _reselect.createSelector)([_getAllCallLogs, notificationEntitiesSelector], (_notifications, notifications) => {
  if (!_notifications) return [];
  return _notifications.reduce((acc, n) => {
    if (notifications[n]) acc.push(notifications[n]);
    return acc;
  }, []);
});